<template>
    <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
            <a
                class="nav-link"
                id="add-templates-tab"
                data-toggle="tab"
                href="#templates"
                role="tab"
                aria-controls="templates"
                aria-selected="false"
                @click="openSideBar('add-templates-tab')"
                ><img src="/maincss/images/blog-template.svg" />Templates</a
            >
        </li>
        <li class="nav-item" role="presentation">
            <a
                class="nav-link"
                id="add-text-tab"
                data-toggle="tab"
                href="#add-text"
                role="tab"
                aria-controls="add-text"
                aria-selected="false"
                @click="openSideBar('add-text-tab')"
                ><img src="/maincss/images/a_text_img.png" />Add Text</a
            >
        </li>
        <li class="nav-item" role="presentation">
            <a
                class="nav-link"
                id="add-clipart-tab"
                data-toggle="tab"
                href="#add-clipart"
                role="tab"
                aria-controls="add-clipart"
                aria-selected="false"
                @click="openSideBar('add-clipart-tab')"
                ><img src="/maincss/images/frame-landscape.svg" />Add Clipart</a
            >
        </li>
        <li class="nav-item" role="presentation">
            <a
                class="nav-link"
                id="add-shape-tab"
                data-toggle="tab"
                href="#add-shape"
                role="tab"
                aria-controls="add-shape"
                aria-selected="true"
                @click="openSideBar('add-shape-tab')"
                ><img src="/maincss/images/shape.svg" />Add Shape</a
            >
        </li>
        <li class="nav-item" role="presentation">
            <a
                class="nav-link"
                id="add-patch-tab"
                data-toggle="tab"
                href="#add-patch"
                role="tab"
                aria-controls="add-patch"
                aria-selected="false"
                @click="openSideBar('add-patch-tab')"
                ><img src="/maincss/images/rectshape.svg" />Add Patch</a
            >
        </li>
        <li class="nav-item" role="presentation">
            <a
                class="nav-link"
                id="nn-tab1"
                data-toggle="tab"
                href="#nn-tab"
                role="tab"
                aria-controls="nn-tab"
                aria-selected="true"
                @click="openSideBar('nn-tab1')"
                ><img src="/maincss/images/hashtag.svg" />Names & Numbers</a
            >
        </li>
        <!-- <li class="nav-item" role="presentation">
            <a class="nav-link" id="distress-effects-tab" data-toggle="tab" href="#distress-effects" role="tab"
            aria-controls="distress-effects" aria-selected="true"
            @click="openSideBar('distress-effects-tab')"><img src="/maincss/images/image.svg" />Distress Effects</a>
        </li> -->
        <li class="nav-item" role="presentation">
            <a
                class="nav-link"
                id="add-upload-tab"
                data-toggle="tab"
                href="#upload"
                role="tab"
                aria-controls="upload"
                aria-selected="false"
                @click="openSideBar('add-upload-tab')"
            >
                <img src="/maincss/images/Group-9997.svg" />
                Upload
            </a>
        </li>
        <li class="nav-item" role="presentation">
            <a
                class="nav-link"
                id="designs-tab"
                data-toggle="tab"
                href="#designs"
                role="tab"
                aria-controls="designs"
                aria-selected="false"
                @click="openSideBar('designs-tab')"
            >
                <img src="/maincss/images/designs.svg" />
                My Designs
                <span v-if="design_count > 0" class="count_mydesign">{{
                    design_count > 0 ? design_count : ""
                }}</span>
            </a>
        </li>
        <!-- <li class="nav-item" role="presentation">
            <router-link :to="{ name: 'BuildListV3' }" class="nav-link">
                <img src="/maincss/images/builds.svg" />
                My Builds
                <span v-if="design_count > 0" class="count_mydesign">{{
                    design_count > 0 ? design_count : ""
                }}</span>
            </router-link>
        </li> -->
        <li class="nav-item" role="presentation">
            <a
                class="nav-link"
                id="archive-tab"
                data-toggle="tab"
                href="#archive"
                role="tab"
                aria-controls="archive"
                aria-selected="false"
                @click="openSideBar('archive-tab')"
            >
                <img src="/maincss/images/archive_white_icon.svg" />
                My Archive
            </a>
        </li>
         <!-- <li class="nav-item" role="presentation">
            <a class="nav-link" id="designs-tab" data-toggle="tab" href="#designs" role="tab" aria-controls="designs" aria-selected="false" @click="openSideBar('designs-tab')">
                <img src="/maincss/images/drafts.png" />
                Drafts
                <span v-if="design_count>0" class="count_mydesign">{{design_count>0?design_count:''}}</span>
            </a>
        </li>  -->
    </ul>
</template>

<script>
export default {
    data() {
        return {
            greeting: "Left Menus!"
        };
    },
    props: ["design_count"],
    mounted() {},
    created() {},
    computed: {},
    methods: {
        openSideBar(section) {
            this.$emit("open-sidebar", true, section);
        }
    }
};
</script>
